module.exports = __webpack_public_path__ + "static/key-facts-2-76db332308b22d1cadc58334978d5dc0.jpg";